<div #sheetPortal>
  @if (isOpen()) {
  <!-- Backdrop -->
  <button
    type="button"
    class="fixed inset-0 bg-black/25 dark:bg-black/45 backdrop-blur-sm cursor-default"
    style="z-index: 1000"
    aria-label="Close"
    (click)="onClose()"
  ></button>

  <!-- Bottom sheet -->
  <div
    class="fixed bottom-0 left-0 right-0 rounded-t-[28px] bg-white/80 dark:bg-[rgba(15,23,42,0.92)] backdrop-blur-[40px] dark:backdrop-blur-[48px] border-t border-white/30 dark:border-white/10 shadow-[0_-8px_40px_rgba(0,0,0,0.06)] dark:shadow-[0_-8px_40px_rgba(0,0,0,0.5)] pb-8"
    style="z-index: 1001"
  >
    <!-- Handle -->
    <div class="flex justify-center py-3">
      <div class="w-10 h-1 rounded-full bg-black/15 dark:bg-white/20"></div>
    </div>

    <!-- Actions -->
    <div class="flex flex-col">
      @for (action of actions(); track $index) { @if (action.variant ===
      'danger' && !$first) {
      <div class="mx-6 my-1 h-px bg-white/10 dark:bg-white/[0.06]"></div>
      }
      <button
        type="button"
        class="flex items-center gap-3 px-6 py-3.5 text-sm font-medium transition-colors cursor-pointer"
        [class]="action.variant === 'danger'
            ? 'text-red-500 dark:text-red-400 hover:bg-red-500/5'
            : 'text-slate-700 dark:text-cream-100 hover:bg-white/10'"
        (click)="onAction(action)"
      >
        <span
          class="material-symbols-outlined !text-[20px]"
          [class]="action.variant === 'danger' ? '' : ($first ? 'text-primary' : 'text-slate-400')"
          >{{ action.icon }}</span
        >
        {{ action.label }}
      </button>
      }
    </div>
  </div>
  }
</div>
